// extracted by mini-css-extract-plugin
module.exports = {"NavigationLink":"NavigationLink_NavigationLink__3yr1h","active":"NavigationLink_active__KjzHq"};